"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
document.addEventListener("DOMContentLoaded", function() {
    var updateScore = // const gameOverElem = document.getElementById('game-over');
    // Function to update the score
    function updateScore(value) {
        currentScore += value;
        currentScoreElem.textContent = currentScore;
        if (value >= 2048) winMessage.classList.remove("hidden");
    };
    var initializeGame = // Function to initialize the game
    function initializeGame() {
        board = _to_consumable_array(Array(size)).map(function() {
            return Array(size).fill(0);
        });
        placeRandom();
        placeRandom();
        renderBoard();
    };
    var placeRandom = // Function to add 2 or 4 on random free cell
    function placeRandom() {
        var emptyCells = [];
        // Find all empty cells
        for(var i = 0; i < size; i++){
            for(var j = 0; j < size; j++)if (board[i][j] === 0) emptyCells.push({
                row: i,
                col: j
            });
        }
        // if we have free slot...
        if (emptyCells.length > 0) {
            var randomEmptyCell = emptyCells[Math.floor(Math.random() * emptyCells.length)];
            board[randomEmptyCell.row][randomEmptyCell.col] = Math.random() < 0.9 ? 2 : 4;
            var cell = document.querySelector('[data-row="'.concat(randomEmptyCell.row, '"][data-col="').concat(randomEmptyCell.col, '"]'));
            cell.classList.add("new-tile");
        }
    };
    var renderBoard = // Function that displays all changes on the board
    function renderBoard() {
        for(var i = 0; i < size; i++)for(var j = 0; j < size; j++){
            var boardValue = board[i][j];
            var cell = document.querySelector("[data-row='".concat(i, "'][data-col='").concat(j, "']"));
            var cellValue = cell.dataset.value;
            if (boardValue !== 0) {
                cell.dataset.value = boardValue;
                cell.textContent = boardValue;
                if (boardValue !== +cellValue && !cell.classList.contains("new-tile")) cell.classList.add("merged-tile");
            } else {
                cell.dataset.value = 0;
                cell.textContent = "";
                cell.classList.remove("merged-tile", "new-tile");
            }
        }
    };
    var move = function move(direction) {
        // console.log(direction);
        var needRender = false;
        if (direction === "ArrowLeft") {
            for(var i = 0; i < board.length; i++){
                var movedRow = moveLeft(board[i]);
                board[i] = movedRow;
            }
            needRender = true;
        }
        if (direction === "ArrowRight") {
            for(var i1 = 0; i1 < board.length; i1++){
                var movedRow1 = moveRight(board[i1]);
                board[i1] = movedRow1;
            }
            needRender = true;
        }
        if (direction === "ArrowDown" || direction === "ArrowUp") {
            for(var i2 = 0; i2 < size; i2++){
                var verticalRow = [];
                for(var j = 0; j < size; j++){
                    var element = board[j][i2];
                    verticalRow.push(element);
                }
                var uppedVerticalRow = direction === "ArrowUp" ? moveLeft(verticalRow) : moveRight(verticalRow);
                for(var j1 = 0; j1 < uppedVerticalRow.length; j1++)board[j1][i2] = uppedVerticalRow[j1];
            }
            needRender = true;
        }
        if (needRender) {
            placeRandom();
            renderBoard();
            gameOverCheck();
        }
        // Emulate finish game cases
        if (direction === "e") {
            emulateLoseGame();
            gameOverCheck();
        }
        if (direction === "w") {
            emulateWinGame();
            gameOverCheck();
        }
    };
    var moveRight = function moveRight(row) {
        var noZeroRow = row.filter(function(cell) {
            return cell !== 0;
        });
        var moveRightRow = [];
        for(var i = noZeroRow.length - 1; i >= 0; i--){
            var cell = noZeroRow[i];
            if (cell === noZeroRow[i - 1]) {
                moveRightRow.push(cell * 2);
                updateScore(cell * 2);
                i--;
            } else moveRightRow.push(cell);
        }
        moveRightRow.reverse();
        while(moveRightRow.length < 4)moveRightRow.unshift(0);
        return moveRightRow;
    };
    var moveLeft = function moveLeft(row) {
        var noZeroRow = row.filter(function(cell) {
            return cell !== 0;
        });
        var moveLeftRow = [];
        for(var i = 0; i < noZeroRow.length; i++){
            var cell = noZeroRow[i];
            if (cell === noZeroRow[i + 1]) {
                moveLeftRow.push(cell * 2);
                updateScore(cell * 2);
                i++;
            } else moveLeftRow.push(cell);
        }
        while(moveLeftRow.length < 4)moveLeftRow.push(0);
        return moveLeftRow;
    };
    var emulateWinGame = function emulateWinGame() {
        var emulateBoard = [
            [
                2,
                4,
                8,
                16
            ],
            [
                32,
                64,
                128,
                256
            ],
            [
                512,
                1024,
                2048,
                0
            ],
            [
                0,
                1024,
                1024,
                4096
            ]
        ];
        board = emulateBoard;
        renderBoard();
    };
    var emulateLoseGame = function emulateLoseGame() {
        var emulateBoard = [
            [
                2,
                4,
                2,
                4
            ],
            [
                4,
                2,
                4,
                2
            ],
            [
                2,
                4,
                8,
                4
            ],
            [
                4,
                8,
                2,
                0
            ]
        ];
        board = emulateBoard;
        renderBoard();
    };
    var gameOverCheck = function gameOverCheck() {
        // Find empty cell
        for(var i = 0; i < size; i++)for(var j = 0; j < size; j++){
            if (board[i][j] === 0) return;
        }
        // Check vertical marge
        for(var i1 = 0; i1 < size - 1; i1++)for(var j1 = 0; j1 < size; j1++){
            if (board[i1][j1] === board[i1 + 1][j1]) return;
        }
        // Check horizontal marge
        for(var i2 = 0; i2 < size; i2++)for(var j2 = 0; j2 < size - 1; j2++){
            if (board[i2][j2] === board[i2][j2 + 1]) return;
        }
        // Game over baby
        loseMessage.classList.remove("hidden");
    };
    var button = document.querySelector(".button.start");
    var currentScoreElem = document.querySelector(".game-score");
    var startMessage = document.querySelector(".message-start");
    var winMessage = document.querySelector(".message-win");
    var loseMessage = document.querySelector(".message-lose");
    var size = 4;
    var board = [];
    var currentScore = 0;
    button.addEventListener("click", function() {
        initializeGame();
        currentScore = 0;
        updateScore(0);
        button.classList.remove("start");
        button.classList.add("restart");
        startMessage.classList.add("hidden");
        winMessage.classList.add("hidden");
        loseMessage.classList.add("hidden");
    });
    document.addEventListener("keydown", function(e) {
        return move(e.key);
    });
});

//# sourceMappingURL=index.614e9122.js.map
